var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756383343019,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 46536,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C317.568 0 160 157.568 160 352c0 128.992 118.016 265.696 160.992 385.76C385.088 916.8 377.984 1024 512 1024c136 0 126.88-106.688 191.008-285.504C746.112 618.176 864 480 864 352c0-194.432-157.632-352-352-352z m82.944 869.632l-158.656 19.808a1393.92 1393.92 0 0 1-19.136-60.576l-0.288-0.992 198.016-24.736c-2.816 9.44-5.824 19.36-8.448 28.256-4.192 14.368-7.936 26.848-11.488 38.24z m-187.392-72.576A1920 1920 0 0 0 387.872 736h248.512c-3.936 11.488-7.872 23.008-11.264 33.888l-217.568 27.168zM512 960c-32.416 0-47.328-3.744-63.904-40l135.616-16.992C564.064 955.936 549.76 960 512 960z m149.504-288h-298.656c-15.936-34.56-35.072-69.12-53.952-102.944C267.136 494.336 224 417.056 224 352c0-158.816 129.184-288 288-288s288 129.184 288 288c0 64.576-43.2 142.272-84.992 217.44-18.688 33.696-37.696 68.192-53.504 102.56z",
    fill: "currentColor",
    "p-id": 46537
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 160c-105.888 0-192 86.112-192 192a16 16 0 0 0 32 0c0-88.224 71.776-160 160-160a16 16 0 0 0 0-32z",
    fill: "currentColor",
    "p-id": 46538
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLight);
export default __webpack_public_path__ + "static/media/my-light.fca4dfba.svg";
export { ForwardRef as ReactComponent };